import React, { useState, useEffect } from "react";
import { Modal, Card } from "react-bootstrap";
import { styleModalComponent } from "./style";
import Separator from "../separator/separator";

const initialProduct = {
  id: "",
  product_id: {
    id: "",
    product_name: "",
    description: "",
  },
  comments: "",
  quantity: 1,
};
/**
 * @param {String} title Título de la modal
 * @param {Array} products Arreglo de productos
 * @param {Boolean} show Control para mostar la modal
 * @param {Function} handleClose Función para cerrar la modal
 * @returns Modal para presentar los productos de una orden
 */
const ModalProds = ({ title, products, show, handleClose, specialOrder }) => {
  /* console.log(
    "🚀 ~ file: modalProds.js ~ line 13 ~ ModalProds ~ products",
    products
  ); */
  const [currentProducts, setCurrentProducts] = useState([]);

  useEffect(() => {
    if (specialOrder === "SOLUTIONS") {
      let newProd = products[0];
      let points = JSON.parse(products[0].comments);
      newProd.comments =
        "Recoger en la primer dirección :" + points.pointA + " para entregar  :" + points.pointB;
      setCurrentProducts([newProd]);
    } else if (specialOrder === "WISHES") {
      //console.log(products);
      let oldFormat = JSON.parse(products[0].comments);
      let newProds = [];
      oldFormat.forEach((element) => {
        let currProd = {
          id: element.id,
          product_id: {
            id: element.id,
            product_name: element.name,
            netcontent: "NA",
          },
          quantity: element.quantity,
        }; //initialProduct;
        /*  currProd.product_id.product_name = element.name;
        currProd.quantity = element.quantity;
        currProd.id = element.id; */
        newProds.push(currProd);
      });
      setCurrentProducts(newProds);
      //let newProds = products
    } else {
      setCurrentProducts(products);
    }
    return () => {
      //second
    };
  }, []);

  return (
    <Modal
      show={show}
      onHide={handleClose}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title>{title}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div style={styleModalComponent.titlesModalContainer}>
          <div className="row">
            <div className="col" style={styleModalComponent.colsContainer}>
              <Card.Text>Cantidad</Card.Text>
            </div>
            <div className="col" style={styleModalComponent.colsContainer}>
              <Card.Text>Nombre del producto</Card.Text>
            </div>
            <div className="col" style={styleModalComponent.colsContainer}>
              <Card.Text>Contenido</Card.Text>
            </div>
          </div>
        </div>
        {currentProducts.map((product, index) => {
          return (
            <div
              key={product.id + index}
              style={styleModalComponent.textContainer}
            >
              <div className="row">
                <div className="col" style={styleModalComponent.colsContainer}>
                  <Card.Title>{product.quantity}</Card.Title>
                </div>
                <div className="col" style={styleModalComponent.colsContainer}>
                  <Card.Text>{product.product_id.product_name}</Card.Text>
                </div>
                <div className="col" style={styleModalComponent.colsContainer}>
                  <Card.Subtitle className="mb-2 text-muted">
                    {product.product_id.netcontent}
                  </Card.Subtitle>
                </div>
              </div>
              {!!product.comments && (
                <>
                  <Separator altStyle={true} />
                  <div className="row">
                    <div
                      className="col"
                      style={styleModalComponent.colsContainer}
                    >
                      <Card.Text>
                        Comentarios{"\n"}
                        {product.comments}
                      </Card.Text>
                    </div>
                  </div>
                </>
              )}
            </div>
          );
        })}
      </Modal.Body>
    </Modal>
  );
};

export default ModalProds;
